<div class="outer-wrapper" [ngClass]="themeClass">
  <div
    class="inner-wrapper"
    [ngClass]="{
      'thread-wrap': viewType === 'thread'
    }"
  >
    <div
      class="inbox-list-column theme-background-color"
      [ngClass]="{ 'desktop-visible': routerOutletActivated }"
    >
      <div class="upper">
        <div class="first-line">
          <h1>{{ archive ? 'Archived Inbox' : 'Inbox' }}</h1>

          <button
            mat-icon-button
            [matMenuTriggerFor]="menu"
            aria-label="Menu"
            class="inbox-dropdown"
          >
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu="matMenu">
            <button
              *ngIf="!archive"
              mat-menu-item
              [routerLink]="['/org', orgId, 'inbox-archive']"
            >
              <mat-icon class="material-icons-outlined">archive</mat-icon>
              <span>Go to archive</span>
            </button>

            <button
              *ngIf="archive"
              mat-menu-item
              [routerLink]="['/org', orgId, 'inbox']"
            >
              <mat-icon class="material-icons-outlined">message</mat-icon>
              <span>Go to inbox</span>
            </button>
          </mat-menu>

          <button
            mat-raised-button
            color="primary"
            [matMenuTriggerFor]="newMenu"
          >
            <!-- We put an add icon here because AirBnB growth hacker did the experiment, image + text works better https://youtu.be/T9ikpoF2GH0?t=2970 -->
            <mat-icon>add</mat-icon> New
          </button>

          <mat-menu #newMenu="matMenu">
            <button mat-menu-item (click)="newThread('thread')">
              <mat-icon class="material-icons-outlined">chat</mat-icon>
              <span>Thread</span>
            </button>
            <button mat-menu-item [matMenuTriggerFor]="directMessageMenu">
              <mat-icon class="material-icons-outlined">3p</mat-icon>
              <span>Direct message</span>
            </button>
            <mat-menu #directMessageMenu="matMenu">
              <button
                *ngFor="let u of orgUsers"
                mat-menu-item
                [routerLink]="u.link"
              >
                {{ u.name }}
              </button>

              <button
                *ngIf="orgUsersArchived.length"
                mat-menu-item
                [matMenuTriggerFor]="archivedDirectMessageMenu"
              >
                Archived users
              </button>
              <mat-menu #archivedDirectMessageMenu="matMenu">
                <button
                  *ngFor="let a of orgUsersArchived"
                  mat-menu-item
                  [routerLink]="a.link"
                >
                  {{ a.name }}
                </button>
              </mat-menu>
            </mat-menu>
            <button mat-menu-item (click)="newThread('channel')">
              <mat-icon class="material-icons-outlined">chat</mat-icon>
              <span>Channel</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="inbox-list narrow-scrollbar">
        <ng-container *ngFor="let inboxItem of inboxItems; last as isLast">
          <app-inbox-list-item
            [inboxItem]="inboxItem"
            [inArchive]="archive"
          ></app-inbox-list-item>
        </ng-container>
      </div>
    </div>
    <div
      class="outlet"
      [ngClass]="{ 'theme-background-color': screenWidth >= 767 }"
    >
      <router-outlet
        (activate)="onRouterOutletActivate($event)"
        (deactivate)="onRouterOutletDeactivate($event)"
      ></router-outlet>
    </div>
    <div></div>
  </div>
</div>
